import { useState } from "react";
import useReveal from "@/hooks/useReveal";
import NotifyMeModal from "@/components/NotifyMeModal";

const WATCH_IMAGE =
  "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/yrumj0o4_Afrqa%20watch.PNG";

export default function WatchPreview() {
  const [open, setOpen] = useState(false);
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section
      id="watch"
      data-testid="watch-preview-section"
      className="relative bg-[#070707] py-24 md:py-40 overflow-hidden"
    >
      {/* Subtle gold ambient glow */}
      <div
        aria-hidden
        className="absolute -left-40 top-1/2 w-[520px] h-[520px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(212,175,55,0.10) 0%, transparent 65%)",
        }}
      />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div
            ref={r1.ref}
            className={`reveal ${r1.inView ? "in-view" : ""} lg:col-span-5 order-2 lg:order-1`}
          >
            <span
              className="inline-flex items-center gap-2 border border-[#d4af37]/60 text-[#d4af37] font-label py-1.5 px-3"
              data-testid="watch-coming-soon-badge"
            >
              <span className="pulse-dot" />
              Coming Soon
            </span>
            <h2 className="mt-8 font-display text-[clamp(2rem,4.6vw,4rem)] leading-[1.04] tracking-tight text-white">
              The{" "}
              <span className="font-editorial italic gold-text-gradient">
                Africa
              </span>{" "}
              Timepiece
              <span className="gold text-[0.4em] align-super ml-1">™</span>
            </h2>
            <p className="mt-6 text-[#bdbdb7] text-lg leading-relaxed max-w-md font-light">
              The first timepiece sculpted in the silhouette of the
              continent. Edition 002 — coming soon.
            </p>

            <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3 text-[#9a9a93] font-label">
              <li>Africa-Shaped</li>
              <li>Stainless Steel</li>
              <li>Gold Indices</li>
              <li>Italian Leather</li>
            </ul>

            <button
              type="button"
              onClick={() => setOpen(true)}
              data-testid="watch-notify-btn"
              className="mt-10 btn-ghost-gold"
            >
              Notify Me on Launch
            </button>
          </div>

          <div
            ref={r2.ref}
            className={`reveal reveal-delay-2 ${
              r2.inView ? "in-view" : ""
            } lg:col-span-7 order-1 lg:order-2`}
          >
            <div className="relative zoom-wrap aspect-[5/6] bg-[#e6d5b8] border border-[#1f1f1f]">
              <img
                src={WATCH_IMAGE}
                alt="The Africa Timepiece — Africa-shaped black & gold watch"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between">
                <span className="font-label text-[#d4af37]">Edition 002</span>
                <span className="font-editorial italic text-white text-2xl drop-shadow-lg">
                  · Coming 2026
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <NotifyMeModal
        open={open}
        onOpenChange={setOpen}
        productSlug="africa-watch"
        productName="The Africa Timepiece™"
      />
    </section>
  );
}
